import React from 'react';
import { Bar } from 'react-chartjs-2';
import { prepareKeywordChartData } from './metricsHelpers';

const KeywordsTab = ({ keywordMetrics }) => {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h3 className="text-lg font-semibold text-gray-700 mb-4">Keyword Statistics</h3>

      {keywordMetrics && typeof keywordMetrics === 'object' ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Primary Keywords */}
          <div>
            <h4 className="text-md font-medium text-gray-700 mb-3">Primary Keywords</h4>
            {keywordMetrics.primary && keywordMetrics.primary.length > 0 ? (
              <Bar
                data={prepareKeywordChartData(keywordMetrics, 'primary')}
                options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      display: false
                    }
                  },
                  scales: {
                    y: {
                      beginAtZero: true
                    }
                  }
                }}
              />
            ) : (
              <p className="text-gray-500 italic">No primary keyword data available</p>
            )}
          </div>

          {/* Secondary Keywords */}
          <div>
            <h4 className="text-md font-medium text-gray-700 mb-3">Secondary Keywords</h4>
            {keywordMetrics.secondary && keywordMetrics.secondary.length > 0 ? (
              <Bar
                data={prepareKeywordChartData(keywordMetrics, 'secondary')}
                options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      display: false
                    }
                  },
                  scales: {
                    y: {
                      beginAtZero: true
                    }
                  }
                }}
              />
            ) : (
              <p className="text-gray-500 italic">No secondary keyword data available</p>
            )}
          </div>
        </div>
      ) : (
        <p className="text-gray-500 italic">No keyword data available</p>
      )}
    </div>
  );
};

export default KeywordsTab;
